import { default as Icon } from './Icon';

export default Icon;
